#import "@/v1-console/currentUser/tenant/currentUser.tenant.fragment.gql"
#import "@/v1-console/featureAccess/featureAccess.fragment.gql"
#import "@/v1-console/package/package.fragment.gql"
#import "@/v1-console/packageAccess/packageAccess.fragment.gql"
#import "@/v1-console/project/project.fragment.gql"

fragment CurrentUserFragment on CurrentUser {
  Id
  AzureID
  FirstName
  LastName
  Email
  IsBlocked
  CreatedAt
  LayerPreferences
  Traits
  TaskEmailNotification
  IsStaff
  IsAdminOfActiveTenant
  ActiveTenantId
  ActiveTenant {
    Id
    Name
    HasModelCalculator
    CadastresFromCompaniesDisplayedOnMapByOrgNumbers
    ExternalCustomerId
  }
  ActiveProjectId
  ActiveProject {
    ...ProjectFragment
  }
  UserTenants {
    ...CurrentUserTenantFragment
  }
  FeatureAccesses {
    ...FeatureAccessFragment
  }
  Package {
    ...PackageFragment
  }
  PackageAccesses {
    ...PackageAccessFragment
  }
}
